import { realEstateRoutePaths } from './paths';

import type { RouteObject } from 'react-router-dom';

export const realEstateRoute: RouteObject[] = [
  {
    path: realEstateRoutePaths.realEstate.path,
    async lazy() {
      const Page = await import('@/pages/real-estate/real-estate-page');
      return { Component: Page.default };
    },
  },
  {
    path: realEstateRoutePaths.trades.path,
    async lazy() {
      const Page = await import('@/pages/real-estate/trades-page');
      return { Component: Page.default };
    },
  },
  {
    path: realEstateRoutePaths.complex.path,
    async lazy() {
      const Page = await import('@/pages/real-estate/complex-detail-page');
      return { Component: Page.default };
    },
  },
  {
    path: realEstateRoutePaths.loan.path,
    async lazy() {
      const Page = await import('@/pages/real-estate/loan-calculator-page');
      return { Component: Page.default };
    },
  },
  {
    path: realEstateRoutePaths.buildings.path,
    async lazy() {
      const Page = await import('@/pages/real-estate/buildings-page');
      return { Component: Page.default };
    },
  },
  {
    path: realEstateRoutePaths.subscriptions.path,
    async lazy() {
      const Page = await import('@/pages/real-estate/subscriptions-page');
      return { Component: Page.default };
    },
  },
  {
    path: realEstateRoutePaths.watchlist.path,
    async lazy() {
      const Page = await import('@/pages/real-estate/watchlist-page');
      return { Component: Page.default };
    },
  },
  {
    path: realEstateRoutePaths.score.path,
    async lazy() {
      const Page = await import('@/pages/real-estate/subscription-score-page');
      return { Component: Page.default };
    },
  },
  {
    path: realEstateRoutePaths.affordability.path,
    async lazy() {
      const Page = await import('@/pages/real-estate/affordability-page');
      return { Component: Page.default };
    },
  },
  {
    path: realEstateRoutePaths.map.path,
    async lazy() {
      const Page = await import('@/pages/real-estate/map-page');
      return { Component: Page.default };
    },
  },
];
